import { render, staticRenderFns } from "./OrdersEdit.vue?vue&type=template&id=0d70414e&"
import script from "./OrdersEdit.vue?vue&type=script&lang=ts&"
export * from "./OrdersEdit.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrdersEdit.vue"
export default component.exports